import React, { Component } from 'react';
import {Container, Grid, Icon, Button, Modal, Header} from 'semantic-ui-react'
import {notify} from 'react-notify-toast';
import { translate } from 'react-i18next';
import API from '../utils/API'
var fileDownload = require('js-file-download');

class PersonalDataPane extends Component {

  constructor(props) {
    super(props)
    this.state = {
      pdataFetching: false,
      deleteFetching: false,
      deleteModalOpen: false
    }
  }

  async downloadPersonalData() {
    this.setState({pdataFetching: true})
    const response = await API.getUserPersonalData()
      if (response.ok) {
        this.setState({pdataFetching: false})
        fileDownload(JSON.stringify(response.data), 'GOWOD_data.json');
      } else {
        notify.show(this.props.t('messages:pdataKO'), 'error')
        this.setState({pdataFetching: false})
      }
  }

  async deleteAccount () {
    this.setState({deleteFetching: true})
    const response = await API.deleteUserAccount()
      if (response.ok) {
        this.setState({deleteFetching: false})
        delete window.localStorage.gwps
        window.location.reload()
      } else {
        notify.show(this.props.t('messages:deleteKO'), 'error')
        this.setState({deleteFetching: false})
      }
  }

  render() {
    const { t } = this.props
    const { deleteModalOpen, pdataFetching, deleteFetching } = this.state
    return (
          <div id="pdata-pane">
            <Container text>
            <div style={{position: 'relative', borderBottom: '1px solid black', marginBottom: '1rem'}}>
                  <h2 style={{textTransform: 'uppercase', marginBottom: '1rem'}}>{t('tabs:pdata')}</h2>
                </div>
              <p>{t('pdata:title')}</p>
                <ul>
                  <li>{t('pdata:part1')}</li>
                  <li>{t('pdata:part2')}</li>
                  <li>{t('pdata:part3')}</li>
                </ul>
              
              <h3 id="pdata-management">{t('pdata:manage')}</h3>
              <Grid className="text-center" columns={2} stackable padded>
                <Grid.Column>
                  <Button icon size='large' loading={pdataFetching} onClick={this.downloadPersonalData.bind(this)}>
                    <Icon name='download' />
                    {t('pdata:download')}
                  </Button>
                </Grid.Column>
                <Grid.Column>
                  <Button color='red' icon size='large' onClick={() => this.setState({deleteModalOpen: true})}>
                    <Icon name='trash' />
                    {t('pdata:delete')}
                  </Button>
                </Grid.Column>
              </Grid>
              <Modal closeIcon open={deleteModalOpen} onClose={() => this.setState({deleteModalOpen: false})}>
                  <Modal.Content>
                    <Modal.Description>
                        <Header>{t('pdata:deleteModal.title')}</Header>
                        <p>{t('pdata:deleteModal.part1')} <br/>
                        {t('pdata:deleteModal.part2')} <b>{t('pdata:deleteModal.part3')}</b>.
                        </p>
                        <p>{t('pdata:deleteModal.part4')} <br/> {t('pdata:deleteModal.part5')}: <a href="https://support.apple.com/HT202039">https://support.apple.com/HT202039</a></p>
                        <div className="text-center mt30">
                          <Button color='grey' negative loading={deleteFetching} onClick={this.deleteAccount.bind(this)}>{t('common:delete')}</Button>
                        </div>
                    </Modal.Description>
                  </Modal.Content>
              </Modal>
            </Container>
          </div>
    )
  }
}
 
export default translate('translations')(PersonalDataPane);


// WEBPACK FOOTER //
// ./src/components/PersonalDataPane.js